import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFileContract, FaArrowLeft } from "react-icons/fa";
import "../../../assets/css/customer/termsConditions/TermsConditions.css";

const SECTIONS = [
    {
        title: "1. User Account",
        body: (
            <p>
                Customers are responsible for providing accurate and complete
                information during registration. Users are also responsible for
                maintaining the confidentiality of their account credentials and for
                all activities performed through their accounts.
            </p>
        ),
    },
    {
        title: "2. Product Information",
        body: (
            <p>
                We make every effort to provide accurate product descriptions,
                images, prices, and specifications. However, slight variations in
                color, texture, or appearance may occur due to lighting, screen
                resolution, or the natural characteristics of furniture materials.
            </p>
        ),
    },
    {
        title: "3. Orders and Payments",
        body: (
            <>
                <p>
                    All orders placed through AD Furniture House are subject to
                    confirmation and product availability.
                </p>
                <p>
                    Online payments are processed securely through <strong>Stripe</strong>.
                    Orders will be processed only after successful payment confirmation.
                </p>
                <p>
                    Customers are responsible for providing accurate delivery
                    information to ensure successful order processing and delivery.
                </p>
            </>
        ),
    },
    {
        title: "4. Pricing",
        body: (
            <>
                <p>
                    All product prices displayed on the website are listed in the
                    applicable currency and may be updated without prior notice.
                </p>
                <p>
                    AD Furniture House reserves the right to correct pricing errors or
                    modify product prices before an order is confirmed.
                </p>
            </>
        ),
    },
    {
        title: "5. Custom Furniture Orders",
        body: (
            <>
                <p>
                    Customers may submit custom furniture requests according to their
                    preferred design and requirements.
                </p>
                <p>
                    Custom furniture will be manufactured based on the information
                    provided by the customer. Customers are responsible for providing
                    accurate measurements, design preferences, and other required
                    details.
                </p>
            </>
        ),
    },
    {
        title: "6. AI Room Design Feature",
        body: (
            <>
                <p>
                    The AI Room Design feature is provided to help customers visualize
                    furniture placement within their rooms.
                </p>
                <p>
                    The generated design suggestions are intended for visualization
                    purposes only and may vary depending on actual room dimensions,
                    lighting conditions, and furniture placement.
                </p>
            </>
        ),
    },
    {
        title: "7. User Responsibilities",
        body: (
            <>
                <p>While using the website, customers agree to:</p>
                <ul className="tc-list">
                    <li>Provide accurate and truthful information.</li>
                    <li>Use the website only for lawful purposes.</li>
                    <li>Respect the rights of other users.</li>
                    <li>
                        Avoid any activity that may damage, disrupt, or interfere with
                        the website's functionality.
                    </li>
                </ul>
            </>
        ),
    },
    {
        title: "8. Intellectual Property",
        body: (
            <p>
                All content available on AD Furniture House, including logos,
                images, product designs, text, graphics, icons, and website content,
                is the property of AD Furniture House and may not be copied,
                reproduced, distributed, or used without prior permission.
            </p>
        ),
    },
    {
        title: "9. Limitation of Liability",
        body: (
            <p>
                AD Furniture House shall not be held responsible for any indirect,
                incidental, or consequential damages arising from the use of the
                website, AI design suggestions, or services, except where required
                by applicable law.
            </p>
        ),
    },
    {
        title: "10. Changes to Terms & Conditions",
        body: (
            <p>
                AD Furniture House reserves the right to update or modify these
                Terms &amp; Conditions at any time. Any changes will become
                effective immediately after they are published on the website.
            </p>
        ),
    },
    {
        title: "11. Contact Us",
        body: (
            <p>
                If you have any questions regarding these Terms &amp; Conditions,
                please contact us through the{" "}
                <a href="/contact-us" className="tc-inline-link">
                    Contact Us
                </a>{" "}
                page available on our website. Our support team will make every
                effort to respond to your inquiries as soon as possible.
            </p>
        ),
    },
];

const TermsConditions = () => {
    const navigate = useNavigate();

    return (
        <div className="tc-page">
            {/* ── Header (centered hero style, same as Privacy Policy) ── */}
            <div className="tc-header">
                {/* Back Button */}
                <button className="tc-back-btn" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back
                </button>
                <div className="tc-header-icon">
                    <FaFileContract />
                </div>
                <h1 className="tc-header-title">Terms &amp; Conditions</h1>
                <p className="tc-header-subtitle">
                    Please read these terms carefully before using AD Furniture House's
                    website and services.
                </p>
            </div>

            {/* ── Content ── */}
            <div className="tc-content">
                <p className="tc-intro">
                    Welcome to <strong>AD Furniture House</strong>. These Terms &amp;
                    Conditions govern your access to and use of our website and
                    services. By creating an account, browsing our website, or placing
                    an order, you agree to comply with these Terms &amp; Conditions.
                </p>

                {SECTIONS.map(({ title, body }, index) => (
                    <section className="tc-section" key={index}>
                        <h2 className="tc-section-title">{title}</h2>
                        <div className="tc-section-body">{body}</div>
                    </section>
                ))}
            </div>
        </div>
    );
};

export default TermsConditions;